<template>
  <div class="header">
    <div class="header-list">
      <div class="header-top">
        <div class="logo">
          <a href="/" title="首页"></a>
        </div>
        <ul class="header-menu">
          <li v-for="(t, i) in headList" :key="i">
            <!--            <router-link :to="t.path" class="router-link-active">-->
            <!--              <span>-->
            <!--                {{ t.title }}-->
            <!--              </span>-->
            <!--            </router-link>-->
            <a :href="t.path" class="router-link-active">
              <span>
                {{ t.title }}
              </span>
            </a>
          </li>
        </ul>
        <div class="header-right">
          <!--          <div class="header-right-l">-->
          <!--                        <img src="../assets/home/img_logo.png" alt="">-->
          <!--          </div>-->
          <div class="header-right-r">
            <!--            <router-link to="/contactUs">-->
            <!--              <el-button type="primary" class="el-button" round>-->
            <!--                <span class="contactUsFont">联系我们</span>-->
            <!--              </el-button>-->
            <a class="contactUsFont" :href="contactUs">
              <span>联系我们</span>
            </a>
            <!--            </router-link>-->
          </div>
        </div>
        <div class="header-emulator">
          <!-- <a
            class="emulator"
            href="https://www.ixuesi.com/courseware/emulatorversion/模拟器版本.zip"
          >
            <span><i class="el-icon-download"></i>下载</span>
          </a> -->
          <el-popover
            popper-class="downloadPopup"
            placement="bottom"
            width="230"
            trigger="click"
          >
            <div class="downloadItem">
              <img
                class="downloadImg"
                src="../assets/image/simulator.png"
                style="margin-right: 5px"
              />
              <a
                class="downloadItemA"
                href="https://www.ixuesi.com/courseware/webSiteDownLoad/emulatorversion/模拟器版本.zip"
                >爱学思智测星模拟器</a
              ><br />
            </div>
            <div class="downloadItem">
              <img
                class="downloadImg"
                src="../assets/image/zhicexing.png"
                style="margin-right: 5px"
              />
              <a
                class="downloadItemA"
                href="https://www.ixuesi.com/courseware/webSiteDownLoad/app/LearningMachine.apk"
                >爱学思智测星</a
              ><br />
            </div>
            <div class="downloadItem">
              <img
                class="downloadImg"
                src="../assets/image/english.png"
                style="margin-right: 5px"
              />
              <a class="downloadItemA" href="https://www.ixuesi.com/courseware/webSiteDownLoad/englishApp/ixsEnglish.apk">英语APP</a>
            </div>
            <el-button class="downloadBtn" slot="reference">下载</el-button>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {ref} from 'vue'
// let headList = ref([
//   {title: '首页', path: '/index'},
//   {title: '关于我们', path: '/aboutUs'},
//   {title: '产品', path: '/product'},
//   {title: '服务', path: '/service'},
//   {title: '新闻中心', path: '/news'}
// ])
export default {
  name: "headMenu",
  data() {
    return {
      headList: [
        { title: "首页", path: "/" },
        { title: "关于我们", path: "#aboutUs" },
        { title: "产品", path: "#product" },
        { title: "服务", path: "#service" },
        // {title: '首页', path: '/index'},
        // {title: '关于我们', path: '/aboutUs'},
        // {title: '产品', path: '/product'},
        // {title: '服务', path: '/service'}
        // {title: '新闻中心', path: '/news'}
      ],
      contactUs: "#contactUs",
      downloadBgUrl: "../assets/image/img_download_bg.png",
    };
  },
  // methods: {
  //   jump () {
  //     this.$router.push('/contactUs')
  //   }
  // }
  methods: {
    // goToAnchor (selector) {
    //   this.$el.querySelector(selector).scrollIntoView({
    //     behavior: 'smooth', // 平滑过渡
    //     block: 'start' // 上边框与视窗顶部平齐
    //   })
    // }
    // goToAnchor () {
    //   // 获取 ref="targetElement" 的 DOM 元素
    //   const targetElement = this.$refs.targetElement
    //
    //   // 使用 scrollIntoView 方法滚动到目标元素
    //   targetElement.scrollIntoView({ behavior: 'smooth' })
    // }
  },
};
</script>

<style scoped>
/*:root {*/
/*  --bgcolor: green*/
/*}*/
.header {
  width: 1920px;
  height: 70px;
  /*background-color: hotpink;*/
  margin: auto;
}

.header-list {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  background-color: #ffffff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.header-top {
  width: 1280px;
  height: 70px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.router-link-active {
  text-decoration: none;
  color: #333333;
}

.logo {
  width: 250px;
}

.logo a {
  background: transparent url("../assets/image/img_logo.png") no-repeat center;
  width: 146px;
  height: 55px;
  display: inline-flex;
  background-size: auto;
  margin-left: 40px;
}

/*头部导航*/
.header-top ul {
  flex: 1;
  display: flex;
}

.header-menu li {
  margin: 0 70px;
  list-style-type: none;
  position: relative;
}

/*.header-top ul li {*/
/*  margin: 0 30px;*/
/*  list-style-type: none;*/
/*  font-size: 18px;*/
/*  font-weight: 500;*/
/*  font-family: PingFang SC;*/
/*}*/

/*.header-top ul li:hover {*/
/*  !*color: var(--bgcolor);*!*/
/*  color: #3E88F3;*/
/*}*/

.header-menu li span {
  /*width: 71px;*/
  height: 17px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 32px;
}

.header-menu li span:hover {
  color: #3e88f3;
}

/*伪元素*/
.header-menu li::before {
  content: "";
  position: absolute;
  bottom: -12px;
  left: 50%;
  width: 0;
  height: 100%;
  border-bottom: 2px solid #3e88f3;
  transition: all 0.2s;
}

.header-menu li:hover::before {
  /*content: '';*/
  /*width: 100%;*/
  /*left: 0;*/
}

/*头部右侧*/
.header-right {
  display: flex;
  /*position: relative;*/
}

.header-emulator {
  /*display: flex;*/
  margin-left: 80px;
}

.header-right-l {
  /*background: url("../assets/home/img_logo.png") no-repeat;*/
  width: 172px;
  /*width: calc(100%/4);*/
  height: 42px;
  margin-right: 10px;
  /*position: absolute;*/
  /*-webkit-mask-box-image: url("../assets/home/img_logo.png");*/
  background: #333333;
}

.header-right-r {
  margin-left: -80px;
}

.header-emulator {
  display: flex;
  margin-right: -200px;
}

.header-right-r p {
  color: #333333;
  font-size: 18px;
  font-weight: 500;
  font-family: PingFang SC;
  /*position: relative;*/
}

.el-button {
  border-radius: 24px;
  width: 138px;
  height: 48px;
  background: #3e88f3;
}

.downloadPopup {
  border-radius: 24px;
}

.downloadImg {
  vertical-align: middle;
}

.downloadItem {
  height: 40px;
  margin-left: 20px;
  margin-bottom: 10px;
}

.downloadItemA {
  line-height: 30px;
  text-decoration: none;
  font-size: 16px;
  color: #333333;
}

/* .downloadItem:hover {
  background-color: #f2f4f7;
} */

.contactUsFont {
  width: 138px;
  height: 48px;
  background: #3e88f3;
  border-radius: 24px;
  display: block;
  text-align: center;
  margin: auto;
}

/* .emulator {
  width: 200px;
  height: 48px;
  background: #3e88f3;
  border-radius: 24px;
  display: block;
  text-align: center;
  margin: auto;
} */

.header-right-r a span {
  width: 64px;
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 32px;
  display: inline-block;
  margin-top: 8px;
}

.downloadBtn {
  width: 128px;
  height: 48px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  display: inline-block;
  text-align: center;
  margin-top: 8px;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/headMenu.vue